(function () {
  if (window.__cdRecsReady) return;
  window.__cdRecsReady = true;

  function refreshDrawer() {
    var drawer = document.querySelector('m-cart-drawer');
    try {
      if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
        MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { source: 'cart-drawer-recs' });
      }
    } catch (e) {}
    if (drawer && typeof drawer.onCartDrawerUpdate === 'function') {
      drawer.onCartDrawerUpdate(true);
      if (!drawer.classList.contains('m-cart-drawer--active') && typeof drawer.open === 'function') {
        drawer.open();
      }
      return true;
    }
    return false;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-cd-add]') : null;
    if (!btn) return;
    event.preventDefault();
    if (btn.getAttribute('aria-busy')) return;
    var label = btn.querySelector('span') || btn;
    var original = label.textContent;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    btn.setAttribute('aria-busy', 'true');
    label.textContent = 'Adding';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-variant-id')), quantity: 1 }] })
    }).then(function (res) {
      if (!res.ok) throw new Error('add failed');
      return res.json();
    }).then(function () {
      if (!refreshDrawer()) window.location.href = root + 'cart';
    }).catch(function () {
      btn.removeAttribute('aria-busy');
      label.textContent = 'Try again';
      window.setTimeout(function () { label.textContent = original; }, 2000);
    });
  });
})();
